import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    order: {
      success: "🎉 Thank You for Your Order!",
      preparing: "Your MirrorProfiles accounts are being prepared. Hang tight—we’ll notify you as soon as they’re ready!",
      orderDetails: "Order Details",
      orderDate: "Order Date",
      europeanAccounts: "European Accounts",
      americanAccounts: "American Accounts",
      europeanAccounts5: "European Accounts:",
      americanAccounts5: "American Accounts:",
      nextSteps: "Next Steps",
      step1_title: "We are preparing your LinkedIn accounts.",
      step1_desc: "To ensure the best quality, we perform some manual actions to warm up and configure your LinkedIn profiles properly.",
      step2_title: "You will receive an email with your account details.",
      step2_desc: "Once your accounts are ready, we’ll send you all the information needed to access them securely.",
      step3_title: "Start using your MirrorProfiles accounts!",
      step3_desc: "Log in, connect your profiles to your automation tool, and start scaling your LinkedIn outreach!",
      blog: "Go to Blog",
      help: "Need help? Visit our",
      faq: "FAQ",
      training: "Follow Our Trainings",
      ou: "or",
      "noActiveSubscription": "No active subscription",
      estimatedWait1: "Current Estimated Waiting Time:",
      estimatedWait2: "days",
      Warning: "Due to high demand, we are currently operating on a waiting list.",
      fullWarning: "Your expected delivery time depends on when your order was placed. We are working hard to fulfill orders as quickly as possible. Thank you for your patience!",
      fullWarning2: "Your subscription will only renew one month after the accounts have been effectively delivered—not from the date of your order."
    },
    login: {
      title: 'Sign in',
      email: 'Email address',
      email_auto: 'Email address {tools}:',
      password: 'Password',
      password_auto: 'Password {tools}:',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      signInButton: 'Sign-in',
      readyToUseAccounts: "Access your ready-to-use LinkedIn accounts and start prospecting today",
      satisfiedUsers: "Satisfied Users",
      activeAccounts: "Active Accounts",
      safetyGuarantee: "Ban rates",
      connections: "Connections",
      review1: "Great! I use this tool for my outbound campaigns to protect my colleagues' LinkedIn accounts. The accounts are warmed up, customizable, and can easily adapt to my personas. A must-have for effectively scaling your outbound strategy!",
      accountsNumber1: "Number of accounts: <strong>10</strong>",
      verticalizeAccounts: "Verticalize accounts per clients",
      dedicatedAccount: "Use dedicated account",
      review2: "Strong knowledge on Linkedin limitations and work around, fast support. Quality of the profiles, advice on how to customize them without risk, very fast reply by the support, nice and efficient team.",
      accountsNumber2: "Number of accounts: <strong>14</strong>",
      scaleVolume: "Scale prospecting volume",
      secureOutbound: "Secure LinkedIn Outbound",
      enterEmail: "Enter your email so that we can send you a password reset link.",
      emailPlaceholder: "Enter your email",
      sendEmail: "Send Email",
      backToLogin: "Back to Login",
      backToSetting: "Back to parameters",
      "email_sent": "An email has been sent to your inbox. Please check.",
      "email_error": "An error occurred while sending the email. Please try again.",
      "password_updated": "Your password has been successfully updated.",
    },
    MainLayout: {
        accounts: 'Accounts',
        billing: 'Billing',
        developer: 'Developer',
        help: 'Help',
        academy: 'Academy',
        settings: 'Settings',
        language: 'Language',
        logout: 'Logout',
        retour: 'Back',
        gologin: 'Gologin',
        multiuser: 'Team',
      },
      accounts: {
        title: 'Accounts',
        totalAccounts: '{count} accounts',
        getNewAccounts: 'GET NEW ACCOUNTS',
        filter: 'Filter',
        sortBy: 'Sort by',
        launchSession: 'Launch session',
        strike: 'Strike',
        detailsTitle: 'Details',
        fullName: 'Full name:',
        company: 'Company:',
        jobTitle: 'Jobtitle:',
        numberOfConnections: 'Number of connections:',
        email: 'Email:',
        password: 'Password:',
        subscriptionDate: 'Subscription date:',
        urlLinkedIn: 'Url LinkedIn:',
        viewLinkedInProfile: 'Link',
        actionsTitle: 'Actions',
        get2FA: 'Get the 2FA',
        invalidEmail: "Only for gmail are allowed.",
        testProxy: 'Test the proxy',
        proxyResponseTime: "response time",
        proxyError: "Proxy connection failure",
        reportProblem: 'Report a problem',
        addAutomationTool: 'Add automation tool',
        removeFromSubscription: 'Remove from subscription',
        addAutomationTitle: "Add an Automation Tool",
        selectTool: "Select a Tool",
        submit: "Submit",
        cancel: "Cancel",
        reportProblemTitle: "Report a Problem",
        problemType: "Type of Problem",
        problemDescription: "Description",
        problemDescriptionPlaceholder: "Provide additional details about the problem...",  
        automationSuccess: "Automation tool added successfully!",
        automationError: "Failed to add automation tool.",
        problemSuccess: "Problem reported successfully!",
        problemError: "Failed to report the problem.",
        linksSent: "Links sent",
        connectionRequests: "Number of connection requests per day",
        profileVisits: "Number of profile visits per day",
        autoProfileVisits: "Auto profile visits?",
        automationToolUsed: "Automation tool used",
        enterNumber: "Enter a number",
        problemTypes: {
            inaccessibleAccount: "Account not accessible",
            gologinIssue: "GoLogin Issue",
            accountDisconnected: "Account Disconnected",
            other: "Other",
        },
        pendingAccount: "Pending account",
        preparingAccount: "Preparing...",
        sortAsc: 'Date ↑',
        sortDesc: 'Date ↓',
        addedSoon: 'Added soon',
        replaceAccountTitle: "Replace Account",
        replaceAccountInstruction: "Fill this form to request a replacement for your account",
        linksSentQuestion: "Have you sent external links in your LinkedIn messages?",
        manualOrAutomatic: "If yes, was it manually or automatically?",
        manual: "Manual",
        automatic: "Automatic",
        stopSubscriptionTitle: 'When do you want to stop the subscription?',
        renewalDate: 'Renewal date',
        removeOption: 'Select removal option',
        removeNow: 'Now',
        removeEndOfMonth: 'At the end of the month',
        removeWarning: 'Cancellations can take effect immediately or at the end of your subscription period. Current month\'s fees are non-refundable.',
        remove: 'Remove',
        subscriptionRemoved: 'Subscription successfully removed.',
        subscriptionRemovedNow: "The subscription has been removed immediately.",
        subscriptionRemovedEnd: "The subscription will be removed at the end of the current period.",
        subscriptionRemoveError: "An error occurred while removing the subscription.",
        noAccountSelected: "No account selected.",
        Search: "Search...",
        Replace: "Replace",
        back: "Back",
        filterLocation: "Location",
        filterGender: "Gender",
        allLocations: "All",
        europe: "Europe",
        usa: "USA",
        allGenders: "All",
        male: "Male",
        female: "Female",
        dateAjout: "Date account added",
        modalreasonLabel: "Reason for request",
        modaltitle: "Please complete this form to explain why you need access to the password.",
        proxyDetails: "Proxy details",
        viewproxyDetails: "See",
        proxyTextInfo: "Discover the details of your proxies in your favorite tools",
        "filterStatus": "Filter by Status",
        "salesNav": "Sales Navigator",
        "pending": "Pending",
        stopSubscriptionSureDesc: "This action is irreversible and will permanently revoke access for this account. Please note that any month started is payable in full.",
        stopSubscriptionSure: "Are you sure you want to remove this account from your subscription ?",
        automationSuccessDesc: "We will get back to you as soon as the automation is set up !",
        SuccessDesc: "We will contact you as soon as possible",
        automationSuccessTitle: "We have taken your request into account",
        "ticketError": "An error occurred while submitting the ticket. Please try again.",
        "ticketSuccess": "The ticket was successfully created!",
        "fillAllFields": "Please fill in all required fields before submitting.",
        proxySlowWarning: "We have received your report and are working to resolve the issue as soon as possible. You will be notified by email as soon as the proxy is corrected. Thank you for your patience.",
        descriptionOptional: "optional",
        "automationTool": "Automation tool",
        "noAutomationTool": "Not set",
        "cancelResiliation": "End of subscription: {resiliationDate}",
        "cancelremove": "Cancel removal",
        "subscriptionCancelRemovedEnd": "Your cancellation has been successfully reversed. You will continue to enjoy your accounts!",
        "subscriptionCancelRemovedEndError": "An error occurred while reversing the cancellation. Please try again or contact our customer service if the issue persists.",
        "stopCancelSubscriptionSure": "Are you sure you want to reverse the cancellation of this account in your subscription?",
        "stopCancelSubscriptionSureDesc": "This action will cancel the termination request and allow you to continue enjoying this account at the next renewal.",
        "compte" : "Account:",
        "copy_success": "Copied to clipboard!",
        "copy_error": "Unable to copy to clipboard.",
        "copy_unsupported": "Copy function is not supported by your browser.",
        CannotReplace: "Replacement pending",
        placeholder: "Enter your reason here...",
        uploadScreenshots: "Please upload screenshots of the messages sent in your automated prospecting campaigns.",
        maxFilesError: "Limit of 10 screenshots.",
        "comment": "Comment",
        "enterComment": "In your opinion, what might have caused this ban?",
        prospectsLocalisation: "Prospects' Location",
        enterProspectsLocalisation: "Enter the prospects location",
        StrikeStep1: "Specify if your messages contain external links (URLs), including links to LinkedIn pages.",
        StrikeStep2: "Average number of connection requests sent per day from this account.",
        StrikeStep3: "Average number of LinkedIn profiles visited daily using this account.",
        StrikeStep4: "Geographic area targeted by your outreach (e.g., France, Île-de-France region, Europe…).",
        StrikeStep5: "Name of the automation tool used to send your messages or manage LinkedIn actions.",
        StrikeStep6: "Add screenshots showing the automated messages sent to prospects to better analyze the context.",
        StrikeStep7: "Describe what you believe might have caused your LinkedIn account to be banned.",
      },
      paymentModal: {
          title: "Renew your subscription to keep your accounts active",
          failedPaymentMessage: "Your last payment on <span class='font-bold'>{date}</span> was unsuccessful, leading to the suspension of <span class='font-bold'>{count}</span> accounts.",
          regainAccess: "To regain access to your MirrorProfiles accounts, please complete the payment now by clicking the button below.",
          payNow: "Pay Now",
          importantNote: "<span class='font-bold'>Important:</span> Please ensure your payment method is up to date to prevent future disruptions and the permanent loss of your accounts.",
          needHelp: "Need help? Contact our support team.",
          contactSupport: "CONTACT SUPPORT"
      },
      otp: {
        noSelectedAccount: 'No selected account or email not found.',
        errorEmailNotFound: 'Error: Email not found',
        otpRequestErrorGmail: 'Error retrieving OTP for Gmail',
        otpRequestError: 'Error retrieving OTP',
        invalidEmail: 'Invalid email. Only @gmail.com and @laposte.net are allowed.',
        otpWebhookErrorLaposte: 'Error calling Laposte webhook',
        noOtpInLastEmail: 'No 2FA code in the last email',
        unexpectedWebhookResponse: 'Unexpected response from Laposte webhook',
        retrievingError: 'Error during OTP retrieval',
      },  
      common: {
            "yes": "Yes",
            "no": "No"
        },
      gologin: {
        title: "Securely access your accounts with Gologin",
        details: "To ensure maximum security, you will access your MirrorProfiles accounts through Gologin. This tool manages your digital fingerprint and IP address, making it appear as if you're always logging in from the same device—keeping your LinkedIn accounts safe and compliant.",
        title1: "Download Gologin",
        title2: "Log in",
        title2_1: "using the credentials below",
        title3: "Launch",
        title3_1: "your profiles and start prospecting securely",
        help: "📌 Need help setting up Gologin?",
        help2: "Check out our step-by-step guide or contact support.",
        button1: "Download Gologin",
        button2: "View Setup Guide",
        getting: "Getting Started in 3 Simple Steps:"
      },
      settings: {
        "emailCopied": "The email has been copied to the clipboard.",
        "emailCopyError": "Error while copying the email.",
        "passwordCopied": "The password has been copied to the clipboard.",
        "passwordCopyError": "Error while copying the password.",
        "passwordNotVisible": "The password is not visible and cannot be copied.",    
        parameters: 'Parameters',
        myAccount: 'My Account',
        email: 'Email',
        password: 'Password',
        company: 'Company',
        language: 'Language',
        integrations: 'Integrations',
        apiKey: 'API Key',
        show: 'Show',
        hide: 'Hide',
        logout: 'Log out',
        "editName": "Edit Company Name",
        "newName": "New Name",
        "namePlaceholder": "Enter a new name",
        "cancel": "Cancel",
        "save": "Save",
        "languageUpdateSuccess": "Language updated successfully.",
        "languageUpdateError": "Error updating account language.",
        "nameUpdateSuccess": "Name updated successfully.",
        "nameUpdateError": "Error updating name."     
      },
      academy: {
        title: 'Academy',
        description:
          'Master LinkedIn prospecting with our academy: Learn from Frédéric, our co-founder and LinkedIn expert, to become a true expert in LinkedIn outreach and make the most of MirrorProfiles',
        accessButton: 'Access the training',
        moduleTitle: 'Video module: {title}',
        modules: {
          1: {
            title: 'Boost your Linkedin acquisition',
            description:
              'With over 6 years of experience in Linkedin prospecting, Frédéric, co-founder of MirrorProfiles, shares strategies, tips, and advice to maximize your Linkedin accounts usage. Get ready to learn a lot about Linkedin prospecting 🚀',
          },
          2: {
            title: 'Become an expert in Linkedin copywriting',
            description:
              'Being able to send thousands of messages on Linkedin is great! But with the right message, it makes all the difference. In this video, Frédéric shares examples of effective prospecting messages that convert. Ready your keyboards and prepare to understand the mysteries of an effective Linkedin campaign ⌨',
          },
          3: {
            title: 'Linkedin KPIs. What goals?',
            description:
              'Do I have a good acceptance rate, response rate? In short, is my Linkedin campaign performing well? Frédéric shares the right statistics to aim for on Linkedin and, of course, reveals his secrets to achieving your goals, both quantitative and especially qualitative. Learn how to analyze and improve your Linkedin campaigns 💪',
          },
          4: {
            title: 'Build a prospecting file with SalesNavigator',
            description:
              'The core of prospecting? It is the data, and it is the one topic where everyone agrees. To have quality prospect files, you need to learn the subtleties of Linkedin SalesNavigator. Ready to master SalesNavigator filters like a pro? Frédéric shares all his tips on this tool 🎯',
          },
          5: {
            title: 'Learn to handle responses on Linkedin',
            description:
              "Don't be too salesy, that's rule number one for prospecting on Linkedin. You need to reply to all prospects, whether they're interested, undecided, or not. In this training, Frédéric shows how to increase your meeting rate through simple but effective tips. Convert more prospects into quality client meetings. Let's go! 📈",
          },
          6: {
            title: 'The art of using MirrorProfiles autonomously',
            description:
              'Like any growth hacking tool, using MirrorProfiles autonomously requires a short training. In just a few minutes, Frédéric shares everything you need to know about our tool. Accelerate your Linkedin prospecting by multiplying the number of Linkedin accounts with MirrorProfiles.',
          },
        }
      },
      "problemTypes": {
        "accountInaccessible": "Account inaccessible",
        "gologinIssue": "GoLogin Issue",
        "accountDisconnection": "Account disconnection",
        "linkedinEmailIssue": "Email inaccessible on LinkedIn",
        "salesnav": "Sales Navigator no longer accessible",
        "other": "Other"
      },
      "errorCodes": {
        "1": "Erreur interne du serveur.",
        "3": "An account with this email already exists. Please log in to the client portal to subscribe to new accounts."
      },
      routes: {
        "accounts": {
          "title": "Client Area - Manage your LinkedIn accounts with MirrorProfiles",
          "description": "Access all your MirrorProfiles accounts in your client area. View details, manage settings, and take necessary actions for effective and secure usage."
        },
        "academy": {
          "title": "MirrorProfiles Academy | Master LinkedIn and Boost Your Prospecting",
          "description": "Become an expert in LinkedIn prospecting with the MirrorProfiles Academy. Access exclusive training to learn how to use your accounts effectively, improve your campaigns, and maximize your results."
        },
        "settings": {
          "title": "Account Settings | MirrorProfiles",
          "description": "Easily manage your MirrorProfiles account settings. Update your personal information, adjust language preferences, and secure your access with ease."
        },
        "subscription": {
          "title": "Subscribe to Your MirrorProfiles LinkedIn Accounts",
          "description": "Choose the number and type of LinkedIn accounts suited to your prospecting needs with MirrorProfiles. European or American accounts, ready to use with 500+ connections and optimal configuration in just a few clicks."
        },
        "addons": {
          "title": "Add Add-ons to Your MirrorProfiles Accounts",
          "description": "Customize your LinkedIn accounts with exclusive add-ons: automation tools, centralized message management, and advanced features to boost your prospecting. Tailor your services to your needs in just a few clicks."
        },
        "summary": {
          "title": "Subscription Summary | MirrorProfiles",
          "description": "View the summary of your LinkedIn accounts and selected add-ons with MirrorProfiles. Review your choices and finalize your subscription with confidence."
        },
        "success": {
          "title": "Subscription Successful | MirrorProfiles",
          "description": "Your subscription to MirrorProfiles is confirmed! Your personalized LinkedIn accounts are being prepared. Receive all the details within 48 hours and start using them with ease."
        },
        "login": {
          "title": "Login to Your MirrorProfiles Dashboard",
          "description": "Log in to your MirrorProfiles client area to access your ready-to-use LinkedIn accounts. Manage your profiles, track information, and optimize your prospecting securely."
        },
        "changePassword": {
          "title": "Change Your Password | MirrorProfiles",
          "description": "Secure your MirrorProfiles access by changing your password. Update it in a few simple steps to protect your MirrorProfiles accounts."
        },
        "forgotPassword": {
          "title": "Forgot Password | MirrorProfiles",
          "description": "Forgot your password? Enter your email address to receive a reset link and securely regain access to your MirrorProfiles client area."
        },
        "paymentCancelled": {
          "title": "Payment Cancelled | MirrorProfiles",
          "description": "Your payment has been cancelled. If you have any questions or need assistance, our team is here to help. Retry your order with ease."
        },
        "createPassword": {
          "title": "Create Your Password | MirrorProfiles",
          "description": "Set up your password to access your MirrorProfiles client area. Complete your registration and start managing your LinkedIn accounts securely."
        },
        "panier": {
          "title": "Complete Your Order | MirrorProfiles",
          "description": "Your cart is waiting! Get ready-to-use LinkedIn profiles and boost your prospecting starting today."
        },
        "confirm": {
          "title": "Almost Done | MirrorProfiles",
          "description": "Validate your cart and access LinkedIn profiles ready for automation. Simple, fast, and commitment-free."
        },
        "inscription": {
          "title": "Sign Up for MirrorProfiles | Ready-to-Use LinkedIn Profiles",
          "description": "Join MirrorProfiles in 1 minute. Get optimized LinkedIn profiles for prospecting, compatible with your automation tools."
        },
        "gologin": {
          "title": "Secure Login via Gologin | MirrorProfiles",
          "description": "Access your LinkedIn profiles securely via Gologin. Dedicated IP and protected fingerprint for safe usage."
        },
        "team": {
          "title": "Manage Your Team | MirrorProfiles",
          "description": "Invite team members and manage your LinkedIn profiles together. Collaborate efficiently from your MirrorProfiles dashboard."
        },
        "waitingList": {
          "title": "Order Confirmed | MirrorProfiles",
          "description": "Thank you for your order! Your LinkedIn profiles are being prepared. An email will be sent to you as soon as they are ready."
        }
      },
      checkout: {
        connections_label: "+500 connections",
        invoices_label: "Invoices available",
        warmup_label: "3 months of warmup",
        support_label: "Responsive customer service (5d/7)",
        commitment_label: "No commitment",
        restriction_label: "-5% restriction",
        title: "Subscribe to a LinkedIn account ready for automation in a few clicks",
        step1: "Add subscriptions",
        step2: "Choose Addons",
        step3: "Summary",
        step3Out: "Payment",
        demoQuestion: "Do you have any questions or want more information about our offers?",
        scheduleDemo: "SCHEDULE A DEMO",
        waitingListInfo3:"",
        waitingListInfo2: "Current wait time: {days} days.",
        waitingListInfo: "We are currently on a waiting list. Subscribing gives you priority access to the next available LinkedIn accounts. The next renewal will occur one month after your LinkedIn account is successfully delivered.",
        step1Title: "Choose the type of account",
        accountsSelected: "accounts selected",
        step2Title: "Choose the number of accounts",
        europeanAccount: "European Account | European Accounts",
        americanAccount: "American Account | American Accounts",
        europeanProfile: "European Account",
        europeanPrice: "100€/month",
        europeanFeature1: "Profile and IP located in <span>Europe</span>",
        europeanFeature2: "Works <a href='{link}' target='_blank' class='underline'>only</a> on <span>European</span> prospects",
        europeanFeature3: "+500 connections and +3 months of warm-up",
        europeanFeature4: "Replaced within 24 hours if needed",
        americanProfile: "American Account",
        americanPrice: "150$/month",
        americanFeature1: "Profile and IP localized to <span>United States</span>",
        americanFeature2: "Works <a href='{link}' target='_blank' class='underline'>only</a> on <span>American</span> prospects",
        americanFeature3: "+500 connections and +3 months of warm-up",
        americanFeature4: "Replaced within 24 hours if needed",
        proceed: "Choose",
        selectAccountTypeError: "Please select an account type before proceeding.",
        compatibilityMessage: "No worries, our profiles are compatible with all the tools on the market as long as they respect <a href='{link}' target='_blank' class='text-blue-600 underline'>quotas and best practices</a>. We can also recommend the best tool based on your needs.",
        pricePerMonth1: "So",
        pricePerMonth2: "/month",
        now: "Now",
        prospectingEurope: "Adapted for prospecting targets in Europe",
        selectAccounts: "Slide to select the number of accounts",
        prospectingUS: "Adapted for prospecting targets in the US",
        addAddons: "Add add-ons",
        optional: "(optional)",
        paymentAfterSubscription: "Billed separately on the partner’s website <br> after subscription.",
        continueButton: "CONTINUE",
        valideButton: "CONFIRM NEW SUBSCRIPTION",
        europeProfile: "Profile located in a country",
        europeProfile2: "of Europe",
        europeIp: "Dedicated IP in",
        europeIp2: "Europe",
        warmup: "+500 connections and +3 months of warmup",
        replacement: "Replaced within 24 hours if needed",
        usProfile: "Profile located in the",
        usProfile2: "United States ",
        usProfile3: "or Canada",
        usIp: "Dedicated IP in the",
        usIp2: "United States ",
        usIp3: "or Canada",
        recapTitle: "Recap of added accounts and add-ons",
        immediatePayment: "Immediate Payment:",
        immediatePaymentDetails: "Details of Immediate Payment",
        seeDetailsButton: "SEE THE PAYMENT DETAILS",
        subscription: "Subscription",
        subscriptionDetails: "Details of Subscription",
        nextBilling: "Monthly subscription for the next billing date:",
        confirmPaymentButton: "CONFIRM AND PROCEED TO PAYMENT",
        paymentSuccess: "🎉 Payment successful. You have subscribed to MirrorProfiles!",
        preparingAccounts: "We are currently preparing your personalized LinkedIn accounts to ensure they are optimized and ready for use.",
        nextStepsTitle: "Next Steps",
        nextSteps: {
          step1: "Check your email inbox for the order confirmation.",
          step2: "Login into your MirrorProfiles client area where you will be able to manage your LinkedIn profiles.",
          step3: "Your accounts will be delivered within",
          step3_2: " {euDays} days for EU and {usDays} days for US.",
          step4: "Connect your accounts to your preferred automation tool and start your campaigns.",
          step5: "Your subscription starts on the day your account is delivered, not when you place your order. This means you only pay for the actual usage period, with no extra charges."
        },
        support: {
          needHelp: "Need help or have any questions? Our team is here to assist you.",
          visitFaq: "VISIT OUR HELP CENTER",
          contactSupport: "BACK TO CUSTOMER AREA"
        },
        features: {
          feature1: "Secure and optimized profiles.",
          feature2: "Ready for automation.",
          feature3: "Fast and dedicated support."
        },
        callToAction: {
          waiting: "While waiting for your accounts, explore our resources to maximize your results.",
          viewGuides: "VIEW OUR GUIDES"
        },
        valider: "CONFIRM",     
        "genderDistributionTitle": "What distribution of Men and Women accounts do you want?",
        genderDistributionTitleUS: "For your American accounts:",
        genderDistributionTitleEU: "For your European accounts:",
        "male": "Man",
        "female": "Woman",
        "limitReached": "Limit reached:",
        "cannotExceedAccounts": "You cannot exceed {count} accounts.",
        "cannotExceedAccountsEU": "You cannot exceed {count} European accounts.",
        "cannotExceedAccountsUS": "You cannot exceed {count} American accounts.",
        "orderConfirmed": "Your order has been successfully placed. We are carefully preparing it.",
        "automationToolLimit": "You are entitled to only one automation tool.",
        "proratatext": "The billed amount is calculated proportionally for the current month. If you add a profile during the month, you will only be charged for the remaining days.",
        "paimentProcess": "PAYMENT IN PROGRESS",
        "addonsSelected": "Addons",
        "totalPrice": "Total",
        "panierTitle": "Your cart is waiting!",
        "panierDescription": "You had items in your cart. Complete your order now!",
        "question": "Do you have questions or want information about our offers?",
        "cta": "Book a demo",
        profil: "account",
        commandTitle: "Nice to see you again, {name}!",
        commandRecap: "You are still logged in. Here is a summary of your selection.",
        commandForgotten: "If you want to use another account or create a new one, you can start over by clicking on ",
        commandForgottenV2: "Log out",
        validcommand: "Edit my order",
        modifycommand: "Confirm my order",
        decoButton: "LOG OUT" 
      },
      inscrit: {
        "title": "Sign up and increase your impact on LinkedIn",
        "text": "We just need a few details before proceeding to payment.",
        "prenom": "First Name",
        "nom": "Last Name",
        "entreprise": "Company",
        "email": "Email",
        "password": "Password",
        "register": "SIGN UP",
        "text1": "Account delivery within 48 hours",
        "text2": "+300 satisfied clients",
        "text3": "No commitment",
        "text4": "Fast and available support 5/7",
        "text5": "Expert and fast support – Available Monday to Friday, from 8 AM to 6 PM (Paris time)",
        "text6": "Available Monday to Friday from 8 AM to 6 PM (Paris time zone).",
        "step1": "Choose your offer",
        "step2": "Choose Addons",
        "step3": "Your information",
        "paye": "PAID",
        "valideButton": "CONTINUE"
      }, 
      setPassword: {
        title: "Set a Password",
        instruction: "Hello, please set a password for your client portal.",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
        submit: "Submit",
        passwordMismatch: "Passwords do not match.",
        passwordTooShort: "Password must be at least 6 characters long.",
        success: "Password successfully set! You can now log in.",
        error: "An error occurred while setting the password."
      },
      "resetPassword": {
        "title": "Reset Password",
        "subtitle": "Please kindly set your new password.",
        "newPassword": "New Password",
        "newPasswordPlaceholder": "Enter your new password",
        "confirmPassword": "Re-Enter Password",
        "confirmPasswordPlaceholder": "Re-enter your password",
        "submitButton": "Reset Password"
      },
      "changePassword": {
        "title": "Change Password",
        "subtitle": "Please enter your current password and set a new password.",
        "currentPassword": "Current Password",
        "currentPasswordPlaceholder": "Enter your current password",
        "newPassword": "New Password",
        "newPasswordPlaceholder": "Enter your new password",
        "confirmPassword": "Re-Enter Password",
        "confirmPasswordPlaceholder": "Re-enter your password",
        "submitButton": "Change Password",
        "passwordMismatch": "Passwords do not match.",
        "error": "An error occurred while changing the password."
      },
      team:{
        title: "Votre équipe",
      },
      "member": {
        "title": "Members",
        "noneFound": "No members found.",
        "firstName": "First Name",
        "lastName": "Last Name",
        "email": "Email",
        "invite": "INVITE",
        "noInvites": "You haven't invited anyone to your team yet. Invite them today to start processing messages together!",
        "confirmDeleteTitle": "Confirm Deletion",
        "confirmDeleteText": "Are you sure you want to delete the member",
        "language": "Language",
        "linkedAccountsTitle": "Linked Accounts:",
        "noLinkedAccounts": "No linked accounts",
        "back": "BACK",
        "delete": "DELETE",
        "accessTitle": "Choose which accounts {name} can access",
        "accessDescription": "The user will only be able to access messages from these LinkedIn profiles",
        "searchPlaceholder": "Search...",
        "sortBy": "Sort by",    
        "selectAll": "Select / Deselect All",
        "add": "ADD",   
        "editTitle": "Edit user:",
        "editDescription": "You can edit this user's information and select the accounts they will have access to.",         
        "modify": "EDIT"
      },
  },
  fr: {
    "member": {
      "title": "Membres",
      "noneFound": "Aucun membre trouvé.",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "E-mail",
      "invite": "INVITER",
      "noInvites": "Vous n'avez encore invité personne dans votre équipe. Invitez-les dès aujourd'hui pour commencer à traiter les messages ensemble !",
      "confirmDeleteTitle": "Confirmer la suppression",
      "confirmDeleteText": "Êtes-vous sûr de vouloir supprimer le membre",
      "language": "Langue",
      "linkedAccountsTitle": "Comptes associés :",
      "noLinkedAccounts": "Aucun compte associé",
      "back": "RETOUR",
      "delete": "SUPPRIMER",
      "accessTitle": "Choisissez les comptes auquel {name} peut accéder",
      "accessDescription": "L'utilisateur n'aura accès uniquement qu'aux messages de ces profils Linkedin",
      "searchPlaceholder": "Rechercher...",
      "sortBy": "Trier par",
      "selectAll": "Tout sélectionner / Désélectionner",
      "add": "AJOUTER",    
      "editTitle": "Modifier l'utilisateur :",
      "editDescription": "Vous pouvez modifier les informations de cet utilisateur et sélectionner les comptes auxquels il aura accès.",
      "modify": "MODIFIER"
    },
    order: {
      success: "🎉 Merci pour votre commande !",
      preparing: "Vos comptes MirrorProfiles sont en cours de préparation. Nous vous notifierons dès qu'ils seront prêts !",
      orderDetails: "Détails de la commande",
      orderDate: "Date de commande",
      europeanAccounts: "Comptes Européens",
      europeanAccounts5: "Comptes Européens :",
      americanAccounts5: "Comptes Américains :",
      americanAccounts: "Comptes Américains",
      nextSteps: "Prochaines étapes",
      step1_title: "Nous préparons vos comptes LinkedIn.",
      step1_desc: "Pour garantir la meilleure qualité, nous effectuons des actions manuelles pour chauffer et configurer correctement vos profils LinkedIn.",
      step2_title: "Vous recevrez un email avec vos identifiants.",
      step2_desc: "Une fois vos comptes prêts, nous vous enverrons toutes les informations nécessaires pour y accéder en toute sécurité.",
      step3_title: "Commencez à utiliser vos comptes MirrorProfiles !",
      step3_desc: "Connectez-vous, intégrez vos profils à votre outil d'automatisation et commencez à développer votre outreach LinkedIn !",
      blog: "Accéder au blog",
      help: "Besoin d'aide ? Consultez notre",
      faq: "FAQ",
      training: "Suivez nos formations",
      ou: "ou",
      estimatedWait1: "Temps d’attente estimé actuel :",
      estimatedWait2: "jours",
      "noActiveSubscription": "Aucun abonnement actif",
      Warning: "En raison d'une forte demande, nous fonctionnons actuellement sur une liste d'attente.",
      fullWarning: "Le délai de livraison dépend de la date à laquelle vous avez passé votre commande. Nous faisons tout notre possible pour les livrer rapidement. Merci pour votre patience !",
      fullWarning2: "Votre abonnement ne sera renouvelé qu’un mois après la livraison effective des comptes — et non à partir de la date de votre commande."
    },  
    login: {
      title: 'Se connecter',
      email: 'Adresse e-mail',
      password: 'Mot de passe',
      rememberMe: 'Se souvenir de moi',
      forgotPassword: 'Mot de passe oublié ?',
      ChangePassword: 'Mot de passe oublié ?',
      signInButton: 'Connexion',
      readyToUseAccounts: "Accédez à vos comptes LinkedIn prêts à l'emploi et commencez à prospecter dès aujourd'hui",
      satisfiedUsers: "Utilisateurs satisfaits",
      activeAccounts: "Comptes actifs",
      safetyGuarantee: "Taux de ban",
      connections: "Connexions",
      review1: "Je recommande ! J'utilise cet outil pour mes campagnes outbound afin de protéger les comptes LinkedIn de mes collègues. Les comptes sont chauffés, personnalisables et s'adaptent facilement à mes personas. Un outil indispensable pour scaler efficacement votre stratégie outbound !",
      accountsNumber1: "Nombre de comptes : <strong>10</strong>",
      verticalizeAccounts: "Verticaliser les comptes par clients",
      dedicatedAccount: "Utiliser un compte dédié",
      review2: "Solide connaissance des limitations de LinkedIn et des contournements, support rapide. Qualité des profils, conseils sur la façon de les personnaliser sans risque, réponse très rapide du support, équipe agréable et efficace.",
      accountsNumber2: "Nombre de comptes : <strong>14</strong>",
      scaleVolume: "Augmenter le volume de prospection",
      secureOutbound: "Sécuriser les campagnes LinkedIn Outbound",
      enterEmail: "Entrez votre e-mail pour que nous puissions vous envoyer un lien de réinitialisation du mot de passe.",
      emailPlaceholder: "Entrez votre e-mail",
      sendEmail: "Envoyer un e-mail",
      backToLogin: "Retour à la connexion",
      backToSetting: "Retour aux parametres",
      "email_sent": "Un e-mail a été envoyé dans votre boîte de réception. Veuillez vérifier.",
      "email_error": "Une erreur est survenue lors de l'envoi de l'e-mail. Veuillez réessayer.",
      "password_updated": "Votre mot de passe a été modifié avec succès."
    },
    MainLayout: {
        accounts: 'Comptes',
        billing: 'Facturation',
        developer: 'Développeur',
        help: 'Aide',
        academy: 'Académie',
        settings: 'Paramètres',
        language: 'Langue',
        logout: 'Déconnexion',
        retour: 'Retour',
        gologin: 'Gologin',
        multiuser: 'Équipe',
      },
      accounts: {
        title: 'Comptes',
        totalAccounts: '{count} comptes',
        getNewAccounts: 'NOUVEAUX COMPTES',
        filter: 'Filtrer',
        sortBy: 'Trier par',
        launchSession: 'Lancer la session',
        strike: 'Strike',
        detailsTitle: 'Détails',
        fullName: 'Nom complet :',
        company: 'Entreprise :',
        jobTitle: 'Poste :',
        numberOfConnections: 'Nombre de relations :',
        email: 'Email :',
        email_auto: 'Email {tools} :',
        password: 'Mot de passe :',
        password_auto: 'Mot de passe {tools} :',
        subscriptionDate: "Date d'abonnement :",
        urlLinkedIn: 'URL LinkedIn :',
        viewLinkedInProfile: 'Lien',
        actionsTitle: 'Actions',
        get2FA: 'Obtenir le 2FA',
        invalidEmail: "Seulement pour gmail",
        testProxy: 'Tester le proxy',
        proxyResponseTime: "temps de réponse",
        proxyError: "Échec connexion proxy",
        reportProblem: 'Signaler un problème',
        addAutomationTool: "Ajouter un outil d'automatisation",
        removeFromSubscription: "Supprimer de l'abonnement",
        addAutomationTitle: "Ajouter un outil d'automatisation",
        selectTool: "Sélectionnez un outil",
        submit: "Soumettre",
        cancel: "Annuler",
        reportProblemTitle: "Signaler un problème",
        problemType: "Type de problème",
        problemDescription: "Description",
        problemDescriptionPlaceholder: "Donnez des détails supplémentaires sur le problème...",
        automationSuccess: "Outil d'automatisation ajouté avec succès !",
        automationError: "Échec de l'ajout de l'outil d'automatisation.",
        problemSuccess: "Problème signalé avec succès !",
        problemError: "Échec de la soumission du problème.",
        problemTypes: {
            inaccessibleAccount: "Compte plus accessible",
            gologinIssue: "Problème GoLogin",
            accountDisconnected: "Déconnexion du compte",
            other: "Autre",
        },
        linksSent: "Liens envoyés",
        connectionRequests: "Nombre de demandes de connexions par jour",
        profileVisits: "Nombre de visites de profils par jour",
        autoProfileVisits: "Visite de profils auto ?",
        automationToolUsed: "Automation tool utilisé",
        enterNumber: "Entrez un nombre",
        pendingAccount: "Compte en attente",
        preparingAccount: "En cours de préparation...",
        sortAsc: 'Date ↑',
        sortDesc: 'Date ↓',
        addedSoon: 'Bientôt ajouté',
        replaceAccountTitle: "Remplacer le compte",
        replaceAccountInstruction: "Remplissez ce formulaire pour demander le remplacement de votre compte",
        linksSentQuestion: "Avez-vous envoyé des liens externes dans vos messages LinkedIn ?",
        manualOrAutomatic: "Si oui, était-ce manuel ou automatique ?",
        manual: "Manuel",
        automatic: "Automatique",
        stopSubscriptionTitle: 'Quand voulez-vous arrêter l’abonnement ?',
        renewalDate: 'Date de renouvellement',
        removeOption: 'Sélectionnez une option de suppression',
        removeNow: 'Maintenant',
        removeEndOfMonth: 'À la fin du mois',
        removeWarning: 'Les annulations peuvent prendre effet immédiatement ou à la fin de votre abonnement. Les frais du mois en cours ne sont pas remboursables.',
        remove: 'Supprimer',
        subscriptionRemoved: 'Abonnement supprimé avec succès.',
        subscriptionRemovedNow: "L'abonnement a été supprimé immédiatement.",
        subscriptionRemovedEnd: "L'abonnement sera supprimé à la fin de la période actuelle.",
        subscriptionRemoveError: "Une erreur est survenue lors de la suppression de l'abonnement.",
        noAccountSelected: "Aucun compte sélectionné.",
        Search: "Recherche...",
        Replace: "Remplacer",
        back: "Retour",
        filterLocation: "Localisation",
        filterGender: "Genre",
        allLocations: "Toutes",
        europe: "Europe",
        usa: "USA",
        allGenders: "Tous",
        male: "Homme",
        female: "Femme",
        modalreasonLabel: "Raison de la demande",
        modaltitle: "Veuillez remplir ce formulaire pour expliquer pourquoi vous avez besoin d'accéder au mot de passe.",
        proxyDetails: "Détails Proxy",
        viewproxyDetails: "Voir",
        proxyTextInfo: "Découvrez les détails de vos proxy à renseigner dans vos outils favoris",
        "filterStatus": "Filtrer par statut",
        "salesNav": "Sales Navigator",
        "pending": "En attente",
        stopSubscriptionSureDesc: "Cette action est irréversible et supprimera définitivement l'accès à ce compte. Veuillez noter que tout mois entamé est payable en totalité.",
        stopSubscriptionSure: "Êtes-vous sûr de vouloir supprimer ce compte de votre abonnement ?",
        automationSuccessDesc: "Nous vous recontacterons dès que l'automatisation sera mise en place !",
        SuccessDesc: "Nous vous recontacterons dès que possible",
        automationSuccessTitle: "Nous avons pris en compte votre demande",
        "ticketError": "Une erreur s'est produite lors de la soumission du ticket. Veuillez réessayer.",
        "ticketSuccess": "Le ticket a été créé avec succès !",
        "fillAllFields": "Veuillez remplir tous les champs requis avant de soumettre."  ,
        proxySlowWarning: "Nous avons bien reçu votre signalement et travaillons à résoudre le problème dans les plus brefs délais. Vous serez notifié par email dès que le proxy sera corrigé. Merci pour votre patience.",
        descriptionOptional: "facultatif",
        "automationTool": "Outil d'automatisation",
        "noAutomationTool": "Non défini",
        "cancelResiliation": "Fin de l'abonnement : {resiliationDate}",
        "cancelremove": "Annuler la résiliation",
        "subscriptionCancelRemovedEnd": "Votre résiliation a été annulée avec succès, vous continuerez à bénéficier de vos comptes !",
        "subscriptionCancelRemovedEndError": "Une erreur est survenue lors de l'annulation de la résiliation. Veuillez réessayer ou contacter notre service client si le problème persiste.",
        "stopCancelSubscriptionSure": "Êtes-vous sûr de vouloir annuler la résiliation de ce compte dans votre abonnement ?",
        "stopCancelSubscriptionSureDesc": "Cette action annulera la demande de résiliation et vous permettra de continuer à profiter de ce compte lors de la prochaine échéance.",
        "compte" : "Compte :",
        "copy_success": "Copié dans le presse-papier !",
        "copy_error": "Impossible de copier dans le presse-papier.",
        "copy_unsupported": "La fonction de copie n’est pas prise en charge par votre navigateur.",
        CannotReplace: "Remplacement en attente",
        placeholder: "Décrivez votre problème ici...",
        dateAjout: "Date d'ajout",
        uploadScreenshots: "Veuillez télécharger des captures d'écran des messages envoyés dans vos campagnes de prospection automatisées.",
        maxFilesError: "Limite de 10 capture d'écran.",
        "comment": "Commentaire",
        "enterComment": "Selon vous, qu’est-ce qui a pu provoquer ce bannissement ?",    
        prospectsLocalisation: "Localisation des prospects",
        enterProspectsLocalisation: "Entrez la localisation des prospects",
        StrikeStep1: "Indiquez si vos messages contiennent des liens externes (URL), y compris vers des pages LinkedIn.",
        StrikeStep2: "Nombre moyen de demandes de connexion que vous avez envoyées chaque jour via ce compte.",
        StrikeStep3: "Nombre moyen de profils LinkedIn que vous avez visités quotidiennement avec ce compte.",
        StrikeStep4: "Zone géographique ciblée par votre prospection (ex. : France, région Île-de-France, Europe…).",
        StrikeStep5: "Nom de l’outil d’automatisation utilisé pour envoyer vos messages ou gérer vos actions LinkedIn.",
        StrikeStep6: "Ajoutez des captures montrant les messages automatisés envoyés aux prospects, afin de mieux analyser le contexte.",
        StrikeStep7: "Décrivez ce qui, selon vous, pourrait avoir causé le bannissement de votre compte LinkedIn.",
      },
      paymentModal: {
        title: "Renouvelez votre abonnement pour garder vos comptes actifs",
        failedPaymentMessage: "Votre dernier paiement du <span class='font-bold'>{date}</span> a échoué, entraînant la suspension de <span class='font-bold'>{count}</span> comptes.",
        regainAccess: "Pour retrouver l'accès à vos comptes MirrorProfiles, veuillez finaliser le paiement en cliquant sur le bouton ci-dessous.",
        payNow: "Payer maintenant",
        importantNote: "<span class='font-bold'>Important :</span> Veuillez vous assurer que votre mode de paiement est à jour pour éviter toute interruption future et la perte définitive de vos comptes.",
        needHelp: "Besoin d'aide ? Contactez notre équipe support.",
        contactSupport: "CONTACTER LE SUPPORT"
      },    
      otp: {
        noSelectedAccount: 'Aucun compte sélectionné ou email introuvable.',
        errorEmailNotFound: 'Erreur : Email introuvable',
        otpRequestErrorGmail: 'Erreur lors de la récupération de l’OTP pour Gmail',
        otpRequestError: 'Erreur lors de la récupération de l’OTP',
        invalidEmail: 'Email invalide. Seuls les emails @gmail.com et @laposte.net sont autorisés.',
        otpWebhookErrorLaposte: "Erreur lors de l'appel au webhook Laposte",
        noOtpInLastEmail: "Pas de code 2FA dans le dernier mail",
        unexpectedWebhookResponse: 'Réponse inattendue du webhook Laposte',
        retrievingError: 'Erreur lors de la récupération de l’OTP',
      },
      common: {
        yes: "Oui",
        no: "Non"
      },
      gologin: {
        title: "Accédez à vos comptes en toute sécurité avec Gologin",
        details: "Pour garantir une sécurité maximale, vous accéderez à vos comptes MirrorProfiles via Gologin. Cet outil gère votre empreinte digitale et votre adresse IP, donnant l'impression que vous vous connectez toujours depuis le même appareil, assurant ainsi la sécurité et la conformité de vos comptes LinkedIn.",
        title1: "Télécharger Gologin",
        title2: "Se connecter",
        title2_1: "avec les identifiants ci-dessous",
        title3: "Lancer",
        title3_1: "vos profils et commencez à prospecter en toute sécurité",
        help: "📌 Besoin d'aide pour configurer Gologin ?",
        help2: "Consultez notre guide étape par étape ou contactez le support.",
        button1: "Télécharger Gologin",
        button2: "Voir le guide d'installation",
        getting: "Commencez en 3 étapes simples :", 
      },
      settings: {
        "emailCopied": "L'email a été copié dans le presse-papier.",
        "emailCopyError": "Erreur lors de la copie de l'email.",
        "passwordCopied": "Le mot de passe a été copié dans le presse-papier.",
        "passwordCopyError": "Erreur lors de la copie du mot de passe.",
        "passwordNotVisible": "Le mot de passe n'est pas visible pour être copié.",    
        parameters: 'Paramètres',
        myAccount: 'Mon Compte',
        email: 'Email',
        password: 'Mot de passe',
        company: 'Entreprise',
        language: 'Langue',
        integrations: 'Intégrations',
        apiKey: 'Clé API',
        show: 'Afficher',
        hide: 'Masquer',
        logout: 'Déconnexion',
        "editName": "Modifier le nom de l'entreprise",
        "newName": "Nouveau nom",
        "namePlaceholder": "Saisissez un nouveau nom",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "languageUpdateSuccess": "Langue mise à jour avec succès.",
        "languageUpdateError": "Erreur lors de la mise à jour de la langue du compte.",
        "nameUpdateSuccess": "Nom mis à jour avec succès.",
        "nameUpdateError": "Erreur lors de la mise à jour du nom."
      },
      academy: {
        title: 'Académie',
        description:
          "Devenez expert en prospection LinkedIn avec notre académie : apprenez grâce à Frédéric, notre co-fondateur et expert LinkedIn, à maîtriser la prospection et à exploiter tout le potentiel de MirrorProfiles.",
        accessButton: 'Accédez à la formation',
        moduleTitle: 'Module vidéo : {title}',
        modules: {
          1: {
            title: 'Boostez votre acquisition Linkedin',
            description:
              "Fort de plus de 6 ans d'expérience en prospection Linkedin, Frédéric, co-fondateur de MirrorProfiles, vous livre les statégies, les astuces et plein de conseils pour maximiser l'utilisation de vos comptes Linkedin. <br> <br> Préparez vous à en apprendre beaucoup sur la prospection Linkedin 🚀",
          },
          2: {
            title: 'Devenez expert en copywriting Linkedin',
            description:
              "Etre capable d'envoyer des milliers de messages sur Linkedin, c'est bien ! Mais avec le bon message, ça fait toute la différence. Dans cette vidéo, Frédéric, vous livre et vous présente des exemples de messages de prospection efficaces et qui transforment. <br><br> A vos claviers, préparez vous à comprendre les mystères d'une campagne Linkedin efficace ⌨",
          },
          3: {
            title: 'KPI Linkedin. Quels objectifs ?',
            description:
              "Ais-je un bon taux d'acceptation, de réponses ? Bref, est-ce que ma campagne Linkedin fonctionne bien ? Frédéric vous livre les bonnes statistiques à avoir sur Linkedin et bien sûre vous livre ses secrets pour atteindre vos objectifs, qu'ils soient quantitatif mais aussi et surtout qualitatif. <br><br> Apprenez à analyser et à améliorer vos campagnes Linkedin 💪",
          },
          4: {
            title: 'Construire un fichier de prospection avec SalesNavigator',
            description:
              "Le nerf de la prospection ? C'est la data, et c'est bien le seul sujet où tout le monde est d'accord. Or, pour avoir des fichiers de prospects de qualité, il vous faudra apprendre les subtilités de Linkedin SalesNavigator. <br><br> Prêt à maîtriser les filtres SalesNavigator comme un pro, Frédéric vous dévoile toutes ses astuces sur cet outil 🎯",
          },
          5: {
            title: 'Apprendre à gérer les réponses sur Linkedin',
            description:
              "Ne soyez pas trop commercial, c'est la règle n°1 de la prospection sur Linkedin. Il faut répondre à tous les prospects, que celui soit intéressé ou non, ou encore indécis. Frédéric vous montre dans cette formation, comment augmenter votre taux de rendez-vous grâce à des astuces simples mais efficaces à mettre en place. <br><br> Convertissez plus de prospects en rendez-vous client de qualités, let's go ! 📈",
          },
          6: {
            title: 'L’art d’utiliser MirrorProfiles en autonomie',
            description:
              "Comme tout outil de Growth hacking, utiliser au mieux MirrorProfiles en autonomie nécessite une petite formation. Frédéric vous livre en quelques minutes chrono, tout ce que vous devez savoir sur notre outil. <br><br> Accélérez votre prospection Linkedin en multipliant le nombre de comptes Linkedin grâce à MirrorProfiles",
          },
        },
      },
      "problemTypes": {
        "accountInaccessible": "Compte plus accessible",
        "gologinIssue": "Problème GoLogin",
        "accountDisconnection": "Déconnexion du compte",
        "linkedinEmailIssue": "Email non accessible sur Linkedin",
        "salesnav": "Sales Navigator n'est plus accessible",
        "other": "Autres"
      },
      checkout: {
        europeanAccount: "Compte Européen | Comptes Européens",
        americanAccount: "Compte Américain | Comptes Américains",
        connections_label: "+500 connexions",
        invoices_label: "Factures disponibles",
        warmup_label: "3 mois de warmup",
        support_label: "Service client réactif (5j/7)",
        commitment_label: "Sans engagement",
        restriction_label: "-5% de restriction",
        title: "Souscrivez à un profil Linkedin prêt à l'automatisation en quelques clics",
        step1: "Ajouter des abonnements",
        step2: "Choisissez des Addons",
        step3: "Récapitulatif",
        step3Out: "Paiement",
        demoQuestion: "Vous avez des questions ou souhaitez des informations sur nos offres ?",
        scheduleDemo: "PRENEZ UNE DÉMO",
        waitingListInfo3:"",
        waitingListInfo2: "Délais d'attente actuel : {days} jours.",
        waitingListInfo: "Nous sommes actuellement en liste d'attente. La souscription vous permet d'avoir les prochains comptes Linkedin disponibles en priorité. Le prochain renouvellement aura lieu 1 mois après la livraison effective de votre compte LinkedIn.",
        step1Title: "Choisissez le type de compte",
        accountsSelected: "comptes sélectionnés",
        step2Title: "Choisissez le nombre de comptes",
        europeanProfile: "Profil Européen",
        europeanPrice: "100€/mois",
        europeanFeature1: "Profil et IP localisés en <span>Europe</span>",
        europeanFeature2: "Fonctionne <a href='{link}' target='_blank' class='underline'>uniquement</a> sur des prospects <span>européens</span>",
        europeanFeature3: "+500 connexions et +3 mois de warmup",
        europeanFeature4: "Remplacé sous 24h en cas de besoin",
        americanProfile: "Profil Américain",
        americanPrice: "150$/mois",
        americanFeature1: "Profil et IP localisé aux <span>États-Unis</span>",
        americanFeature2: "Fonctionne <a href='{link}' target='_blank' class='underline'>uniquement</a> sur des prospects <span>américains</span>",
        americanFeature3: "+500 connexions et +3 mois de warmup",
        americanFeature4: "Remplacé sous 24h en cas de besoin",
        proceed: "Choisir",
        selectAccountTypeError: "Veuillez sélectionner un type de compte avant de continuer.",
        compatibilityMessage: "Pas d'inquiétude, nos profils sont compatibles avec tous les outils du marché tant qu'ils respectent <a href='{link}' target='_blank' class='text-blue-600 underline'>les quotas et bonnes pratiques</a>. Nous pouvons aussi vous recommander le meilleur outil en fonction de vos besoins.",
        pricePerMonth1: "Soit",
        pricePerMonth2: "/mois",
        now: "Immédiat",
        prospectingEurope: "Adaptés pour des cibles de prospection en Europe",
        selectAccounts: "Glissez pour sélectionner le nombre de comptes",
        prospectingUS: "Adaptés pour des cibles de prospection au US",
        addAddons: "Ajoutez des add-ons ",
        optional: "(facultatif)",
        paymentAfterSubscription: "Facturé séparément sur le site du partenaire <br> après l’abonnement.",
        continueButton: "CONTINUER",
        valideButton: "VALIDER LE NOUVEL ABONNEMENT",
        europeProfile: "Profil localisé dans un pays",
        europeProfile2: "d'Europe",
        europeIp: "IP dédiée en",
        europeIp2: "Europe",
        warmup: "+500 connexions et +3 mois de warmup",
        replacement: "Remplacé sous 24h en cas de besoin",
        usProfile: "Profil localisé aux",
        usProfile2: "États-Unis",
        usProfile3: " ou Canada",
        usIp: "IP dédiée aux",
        usIp2: "États-Unis",
        usIp3: " ou Canada",
        recapTitle: "Récapitulatif des comptes ajoutés et des add-ons",
        immediatePayment: "Paiement immédiat :",
        immediatePaymentDetails: "Détails du Paiement Immédiat",
        seeDetailsButton: "VOIR LE DÉTAIL DU PAIEMENT",
        subscription: "Abonnement",
        subscriptionDetails: "Détails de l'Abonnement",
        nextBilling: "Abonnement mensuel à la prochaine échéance :",
        confirmPaymentButton: "CONFIRMER ET PROCÉDER AU PAIEMENT",
        paymentSuccess: "🎉 Paiement réussi. Vous venez de souscrire à MirrorProfiles !",
        preparingAccounts: "Nous préparons actuellement vos comptes LinkedIn personnalisés pour qu'ils soient optimisés et prêts à l'emploi.",
        nextStepsTitle: "Prochaines étapes",
        nextSteps: {
          step1: "Vérifiez votre boîte de réception pour la confirmation de commande.",
          step2: "Connectez-vous à votre espace client MirrorProfiles pour gérer vos profils LinkedIn.",
          step3: "Vos comptes seront livrés sous",
          step3_2: " {euDays} jours pour l’UE et {usDays} jours pour les États-Unis.",
          step4: "Connectez vos comptes à votre outil d'automatisation préféré et lancez vos campagnes.",
          step5: "Votre abonnement commence le jour de la livraison de votre compte, pas au moment de la commande. Vous ne payez donc que pour la période réellement utilisée, sans surcoût."
        },
        support: {
          needHelp: "Besoin d'aide ou de poser des questions ? Notre équipe est là pour vous aider.",
          visitFaq: "VISITEZ NOTRE CENTRE D'ASSISTANCE",
          contactSupport: "RETOUR ESPACE CLIENT"
        },
        features: {
          feature1: "Profils sécurisés et optimisés.",
          feature2: "Prêts pour l'automatisation.",
          feature3: "Support rapide et dédié."
        },
        callToAction: {
          waiting: "En attendant vos comptes, explorez nos ressources pour maximiser vos résultats.",
          viewGuides: "VOIR NOS GUIDES"
        },
        valider: "CONFIRMER",
        "genderDistributionTitle": "Quelle répartition de profils Hommes et Femmes souhaitez-vous ?",
        genderDistributionTitleEU: "Pour vos comptes Européens :",
        genderDistributionTitleUS: "Pour vos comptes Américains :",
        "male": "Homme",
        "female": "Femme",
        "limitReached": "Limite atteinte :",
        cannotExceedAccounts: "Vous ne pouvez pas dépasser {count} comptes.",
        "cannotExceedAccountsEU": "Vous ne pouvez pas dépasser {count} comptes européens.",
        "cannotExceedAccountsUS": "Vous ne pouvez pas dépasser {count} comptes américains.",
        "orderConfirmed": "Votre commande a bien été prise en compte. Nous la préparons avec soin.",
        "automationToolLimit": "Vous avez droit à un seul outil d'automatisation.",
        "proratatext": "Le montant facturé est calculé au prorata du mois en cours. Si vous ajoutez un profil en cours de mois, vous ne paierez que pour les jours restants.",
        "paimentProcess": "PAIEMENT EN COURS",
        "addonsSelected": "Addons",
        "totalPrice": "Total",
        "panierTitle": "Votre panier vous attend !",
        "panierDescription": "Vous aviez des articles dans votre panier. Finalisez votre commande maintenant !",
        "question": "Vous avez des questions ou souhaitez des informations sur nos offres ?",
        "cta": "Prenez une démo",
        profil: "profile",
        commandTitle: "Ravi de vous revoir {name} !",
        commandRecap: "Vous êtes toujours connecté. Voici un récapitulatif de votre sélection.",
        commandForgotten: "Si vous souhaitez utiliser un autre compte ou en créer un nouveau, vous pouvez recommencer en cliquant sur ",
        commandForgottenV2: "Se déconnecter",
        validcommand: "Modifier ma commande",
        modifycommand: "Valider ma commande",
        decoButton: "SE DÉCONNECTER"
      },   
      inscrit: {
        "title": "Inscrivez-vous et augmentez votre impact sur Linkedin",
        "text": "Nous avons seulement besoin de quelques éléments avant de passer au paiement.",
        "prenom": "Prénom",
        "nom": "Nom",
        "entreprise": "Entreprise",
        "email": "Email",
        "password": "Mot de passe",
        "register": "S'INSCRIRE",
        "text1": "Livraison du compte sous 48h",
        "text2": "+300 clients satisfaits",
        "text3": "Sans engagement",
        "text4": "Support rapide et disponible 5j/7",
        "text5": "Support expert et rapide – Disponible du lundi au vendredi, de 8h à 18h (heure de Paris)",
        "text6": "Support reconnu pour sa qualité : rapide et expert. Disponible sur le fuseau horaire de Paris, du lundi au vendredi, de 8h à 18h.",
        "step1": "Choissisez votre offre",
        "step2": "Choisissez des Addons",
        "step3": "Vos informations",
        "paye": "PAYÉ",
        "valideButton": "CONTINUER"
      }, 
      "errorCodes": {
        "1": "Erreur interne du serveur.",
        "3": "Un compte avec cet email existe déjà. Veuillez vous connecter à l'espace client pour souscrire à de nouveaux comptes."
      },
      routes: {
        "accounts": {
          "title": "Espace client - Gérez vos comptes LinkedIn avec MirrorProfiles",
          "description": "Accédez à tous vos comptes MirrorProfiles dans votre espace client. Consultez les détails, gérez les paramètres et effectuez les actions nécessaires pour une utilisation efficace et sécurisée."
        },
        "academy": {
          "title": "Académie MirrorProfiles | Maîtrisez LinkedIn et boostez votre prospection",
          "description": "Devenez expert en prospection LinkedIn avec l’Académie MirrorProfiles. Accédez à des formations exclusives pour apprendre à utiliser vos comptes efficacement, améliorer vos campagnes et maximiser vos résultats."
        },
        "settings": {
          "title": "Paramètres de votre compte | MirrorProfiles",
          "description": "Gérez facilement les paramètres de votre compte MirrorProfiles. Modifiez vos informations personnelles, ajustez les préférences linguistiques et sécurisez votre accès en toute simplicité."
        },
        "subscription": {
          "title": "Souscrivez à vos profils LinkedIn MirrorProfiles",
          "description": "Choisissez le nombre et le type de profils LinkedIn adaptés à votre prospection avec MirrorProfiles. Profils européens ou américains, prêts à l’utilisation avec +500 connexions et une configuration optimale en quelques clics."
        },
        "addons": {
          "title": "Ajoutez des add-ons à vos profils MirrorProfiles",
          "description": "Personnalisez vos comptes LinkedIn avec des add-ons exclusifs : outils d’automatisation, gestion centralisée des messages et fonctionnalités avancées pour booster votre prospection. Adaptez vos services à vos besoins en quelques clics."
        },
        "summary": {
          "title": "Récapitulatif de votre souscription | MirrorProfiles",
          "description": "Visualisez le récapitulatif de vos comptes LinkedIn et des add-ons sélectionnés avec MirrorProfiles. Vérifiez vos choix et finalisez votre souscription en toute confiance."
        },
        "success": {
          "title": "Souscription réussie | MirrorProfiles",
          "description": "Votre souscription à MirrorProfiles est confirmée ! Vos comptes LinkedIn personnalisés sont en préparation. Recevez tous les détails sous 48h et commencez à les utiliser en toute simplicité."
        },
        "login": {
          "title": "Connexion à votre espace MirrorProfiles",
          "description": "Connectez-vous à votre espace client MirrorProfiles pour accéder à vos comptes LinkedIn prêts à l’emploi. Gérez vos profils, suivez les informations et optimisez votre prospection en toute sécurité."
        },
        "changePassword": {
          "title": "Changer votre mot de passe | MirrorProfiles",
          "description": "Sécurisez votre accès à MirrorProfiles en modifiant votre mot de passe. Changez-le en quelques étapes simples pour protéger vos comptes MirrorProfiles."
        },
        "forgotPassword": {
          "title": "Mot de passe oublié | MirrorProfiles",
          "description": "Vous avez oublié votre mot de passe ? Entrez votre adresse e-mail pour recevoir un lien de réinitialisation et retrouver l'accès à votre espace client MirrorProfiles en toute sécurité."
        },
        "paymentCancelled": {
          "title": "Paiement annulé | MirrorProfiles",
          "description": "Votre paiement a été annulé. Si vous avez des questions ou besoin d’assistance, notre équipe est là pour vous aider. Réessayez votre commande en toute simplicité."
        },
        "createPassword": {
          "title": "Créer votre mot de passe | MirrorProfiles",
          "description": "Configurez votre mot de passe pour accéder à votre espace client MirrorProfiles. Finalisez votre inscription et commencez à gérer vos comptes LinkedIn en toute sécurité."
        },
        "panier": {
          "title": "Finalisez votre commande | MirrorProfiles",
          "description": "Votre panier vous attend ! Profitez de profils LinkedIn prêts à l’emploi et boostez votre prospection dès aujourd’hui."
        },
        "confirm": {
          "title": "Commande presque terminée | MirrorProfiles",
          "description": "Validez votre panier et accédez à vos profils LinkedIn prêts à l’automatisation. Simple, rapide et sans engagement."
        },
        "inscription": {
          "title": "Inscrivez-vous à Mirrorprofiles | Profils LinkedIn prêts à l’emploi",
          "description": "Rejoignez MirrorProfiles en 1 min. Profitez de profils LinkedIn optimisés pour la prospection et compatibles avec vos outils d’automatisation."
        },
        "gologin": {
          "title": "Connexion sécurisée via Gologin | MirrorProfiles",
          "description": "Accédez à vos profils LinkedIn en toute sécurité via Gologin. IP dédiée et empreinte digitale protégée pour un usage sans risque."
        },
        "team": {
          "title": "Gérez votre équipe | MirrorProfiles",
          "description": "Invitez vos collaborateurs et gérez vos profils LinkedIn à plusieurs. Collaborez efficacement depuis votre tableau de bord MirrorProfiles."
        },
        "waitingList": {
          "title": "Commande confirmée | MirrorProfiles",
          "description": "Merci pour votre commande ! Vos profils LinkedIn sont en préparation. Un email vous sera envoyé dès qu’ils sont prêts."
        },
      },
      setPassword: {
        title: "Définir un mot de passe",
        instruction: "Bonjour, veuillez définir un mot de passe pour votre espace client.",
        newPassword: "Nouveau mot de passe",
        confirmPassword: "Confirmez le mot de passe",
        submit: "Enregistrer",
        passwordMismatch: "Les mots de passe ne correspondent pas.",
        passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères.",
        success: "Mot de passe défini avec succès ! Vous pouvez maintenant vous connecter.",
        error: "Une erreur est survenue lors de la définition du mot de passe."
      },
      "resetPassword": {
        "title": "Réinitialiser le mot de passe",
        "subtitle": "Veuillez définir votre nouveau mot de passe.",
        "newPassword": "Nouveau mot de passe",
        "newPasswordPlaceholder": "Entrez votre nouveau mot de passe",
        "confirmPassword": "Confirmez le mot de passe",
        "confirmPasswordPlaceholder": "Re-saisissez votre mot de passe",
        "submitButton": "Réinitialiser le mot de passe"
      },
      "changePassword": {
        "title": "Modifier le mot de passe",
        "subtitle": "Veuillez saisir votre mot de passe actuel et définir un nouveau mot de passe.",
        "currentPassword": "Mot de passe actuel",
        "currentPasswordPlaceholder": "Entrez votre mot de passe actuel",
        "newPassword": "Nouveau mot de passe",
        "newPasswordPlaceholder": "Entrez votre nouveau mot de passe",
        "confirmPassword": "Confirmez le mot de passe",
        "confirmPasswordPlaceholder": "Re-saisissez votre mot de passe",
        "submitButton": "Modifier le mot de passe",
        "passwordMismatch": "Les mots de passe ne correspondent pas.",
        "error": "Une erreur est survenue lors de la modification du mot de passe."
      },
      team:{
        title: "Votre équipe",
      }
  },
};

const getBrowserLanguage = () => {
  const savedLang = localStorage.getItem('langue');
  if (savedLang) {
    return savedLang;
  }
  
  const lang = navigator.language || navigator.userLanguage;

  return lang.startsWith('fr') ? 'fr' : 'en';
};

const i18n = createI18n({
  locale: getBrowserLanguage(),
  fallbackLocale: 'en',
  messages,
});

export default i18n;
